import type { Document as RichTextDocument } from '@contentful/rich-text-types';
// biome-ignore lint/correctness/noUnusedImports: Automated migration to Biome
import React from 'react';
import { setImgWidth } from '@/utils/frontify';
import type { ComponentSys } from '../../contentful/contentful-exports';
import type { ImageSectionContent } from '../ImageSection/ImageSection';
import RichText from '../RichText/RichText';
import TaxForm, { type TaxFormContent } from '../TaxForm/TaxForm';
import useStyles from './TaxFormSection.styles';

export interface TaxFormSectionContent {
  fields: {
    title: string;
    header: RichTextDocument;
    footer: RichTextDocument;
    image: ImageSectionContent;
    form: TaxFormContent;
    taxFormImageAltText?: string;
  };
  metaData: {
    tags: [];
  };
  sys: ComponentSys;
}

interface ImageSectionProps {
  content: ImageSectionContent;
}

interface Props {
  content: TaxFormSectionContent;
}

function ImageSection({ content }: ImageSectionProps) {
  const { classes } = useStyles();
  return (
    // biome-ignore lint/performance/noImgElement: Automated migration to Biome
    <img
      className={classes.imageSection}
      src={setImgWidth(content?.fields?.image?.[0]?.preview_url, 1440)}
      alt={content?.fields?.imageSectionAltText}
    />
  );
}

/**
 * @deprecated V2 component
 */
export default function TaxFormSection({ content }: Props) {
  const { title, header, footer, image, form } = content.fields;

  const { classes } = useStyles();

  return (
    <div className={classes.container}>
      {title && <h1 className={classes.mobileTitle}>{title}</h1>}
      <div className={classes.twoColumnTable}>
        <div className={classes.content}>
          {title && <h1 className={classes.title}>{title}</h1>}
          {header && (
            <RichText content={header} title={content.fields?.title} />
          )}
          {image && <ImageSection content={image as ImageSectionContent} />}
          {footer && (
            <RichText content={footer} title={content.fields?.title} />
          )}
        </div>
        <div className={classes.form}>{form && <TaxForm content={form} />}</div>
      </div>
    </div>
  );
}
